import type { ComicPanel, ComicPanelCandidate } from '../../lib/comicTypes'
import { mediaDisplayUrl } from '../../lib/resolvedMediaImage'
import { chromeSelectableMediaCardClass } from '../ChromeSurface'
import { ChromeTooltip } from '../ChromeTooltip'
import { HorizontalChipStrip } from '../HorizontalChipStrip'
import { comicPanelRoundSm } from './comicPanelTokens'

/** 单格候选横向条：点击设为定稿 */
export function ComicPanelCandidateStrip({
  angular,
  panel,
  className = '',
  onSelectCandidate,
  onPreviewCandidate,
}: {
  angular: boolean
  panel: ComicPanel | null
  /** @deprecated 仅兼容旧调用；展示以 candidates 为准 */
  slotCount?: number
  className?: string
  onSelectCandidate?: (candidateId: string) => void
  /** 双击缩略图放大预览 */
  onPreviewCandidate?: (candidateId: string) => void
}) {
  const candidates = panel?.candidates ?? []
  const selectedId = panel?.selectedCandidateId

  if (candidates.length === 0) {
    return null
  }

  return (
    <HorizontalChipStrip
      className={['pb-1', className].join(' ')}
      trackClassName="gap-2"
      role="list"
      aria-label="单格候选"
    >
      {candidates.map((c, i) => (
        <CandidateThumb
          key={c.id}
          angular={angular}
          candidate={c}
          index={i}
          selected={c.id === selectedId}
          onSelect={onSelectCandidate ? () => onSelectCandidate(c.id) : undefined}
          onPreview={onPreviewCandidate ? () => onPreviewCandidate(c.id) : undefined}
        />
      ))}
    </HorizontalChipStrip>
  )
}

function CandidateThumb({
  angular,
  candidate,
  index,
  selected,
  onSelect,
  onPreview,
}: {
  angular: boolean
  candidate: ComicPanelCandidate
  index: number
  selected: boolean
  onSelect?: () => void
  onPreview?: () => void
}) {
  const frame = [
    chromeSelectableMediaCardClass(angular, selected),
    'relative h-20 w-20 shrink-0 bg-surface-muted/45 sm:h-24 sm:w-24',
    comicPanelRoundSm(angular),
    onSelect ? 'cursor-pointer' : '',
  ].join(' ')

  const inner = (
    <>
      <img
        src={mediaDisplayUrl(candidate.imageUrl)}
        alt=""
        className="h-full w-full object-cover"
        draggable={false}
      />
      {selected ? (
        <span className="absolute left-0.5 top-0.5 rounded-[var(--radius-sm)] bg-accent px-1 py-px text-[9px] font-bold text-white">
          定稿
        </span>
      ) : null}
      <span className="absolute bottom-0.5 right-0.5 rounded-[var(--radius-sm)] bg-panel/85 px-1 text-[9px] font-bold tabular-nums text-ink-soft">
        {index + 1}
      </span>
    </>
  )

  if (onSelect) {
    const thumb = (
      <button
        type="button"
        className={frame}
        onClick={onSelect}
        onDoubleClick={(e) => {
          e.preventDefault()
          onPreview?.()
        }}
        aria-pressed={selected}
      >
        {inner}
      </button>
    )
    return onPreview ? (
      <ChromeTooltip content="单击定稿，双击放大预览" angular={angular} side="top" align="center">
        {thumb}
      </ChromeTooltip>
    ) : (
      thumb
    )
  }

  return <div className={frame}>{inner}</div>
}
